import _sfc_main from './code-menu.vue.js';
/* empty css               */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const codeMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-59c1b41e"]]);

export { codeMenu as default };
//# sourceMappingURL=code-menu.js.map
